import React from "react";
import { COLORS } from "../../constants/colors";
import LoadingButton from "../LoadingButton/LoadingButton";
import { Modal as ModalAnt } from 'antd';
import './Modal.css';

interface Props {
    question: string;
    method: () => void;
    loading: boolean;
    visible: boolean;
    title?: React.ReactNode;
    children?: any;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    closable?: boolean;
}

const ConfirmationModal: React.FC<Props> = ({ question, method, loading, visible, setVisible, title = "BisFormulario", closable = true, children }) => {

    return (
        <ModalAnt
            footer={null}
            maskClosable={false}
            keyboard={false}
            title={<nav className="modalComponent_title">{title}</nav>}
            centered={true}
            onCancel={() => setVisible(false)}
            closable={closable}
            destroyOnClose={true}
            visible={visible}
            style={{ top: '-10%' }}
            width="50%"
        >
            <p className="confirmationModal_question">{question}</p>
            <div>
                {children}
            </div>
            <div className="confirmationModal_option">
                <div className="confirmationModal_button">
                    <LoadingButton
                        type="button"
                        method={() => setVisible(false)}
                        title={"No"}
                        disabled={loading ? true : false}
                        style={{ border: '1px solid #C4C4C4', padding: '0px', height: '40px' }}
                        loading={'false'}
                        background={COLORS.white_color1}
                        color={'#818181'}
                        fontsize={18}
                    />
                </div>

                <div className="confirmationModal_button">
                    <LoadingButton
                        type="button"
                        method={method}
                        title={"Si"}
                        style={{ border: '1px solid #C4C4C4', padding: '0px', height: '40px' }}
                        disabled={loading ? true : false}
                        loading={loading.toString()}
                        background={COLORS.white_color1}
                        color={'#818181'}
                        fontsize={18}
                    />
                </div>

            </div>
        </ModalAnt>
    );
}

export default ConfirmationModal;